import { useMutation, useQueryClient } from '@common-fe/common-fe';
import _ from 'lodash';

import { api } from '@/api';
import { RiskControlOptions } from '@/common/constants';
import { INVESTMENTS_FLOW_APPROVE } from '@/common/paths';
import { INVESTOR_GET_QUERY_KEY } from '@/modules/investments/queries/useInvestor.query';
interface Params {
  onSuccess?: () => void;
  onError?: () => void;
}
const useInvestmentApproveQuery = (params?: Params) => {
  const queryClient = useQueryClient();
  const { mutateAsync, isLoading, isSuccess } = useMutation(
    (toleranceModel?: RiskControlOptions) =>
      api.patch(INVESTMENTS_FLOW_APPROVE, undefined, {
        params: _.pickBy({
          model: toleranceModel,
        }),
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [INVESTOR_GET_QUERY_KEY],
        });
        if (params?.onSuccess) {
          params.onSuccess();
        }
      },
      onError: params?.onError,
    }
  );
  return {
    handleSave: mutateAsync,
    isLoading,
    isSuccess,
  };
};

export default useInvestmentApproveQuery;
